// extracted by extract-css-chunks-webpack-plugin
module.exports = {"form":"form___3Bowt","row":"row___1pNVD","full":"full___3cphu","half":"half___2CoEj"};